const name =  'offers'
export default name;